module.exports = __webpack_public_path__ + "static/media/web.871acbbe.png";